import { render, staticRenderFns } from "./UploadImg-ai-v3.vue?vue&type=template&id=7ef06dda&scoped=true"
import script from "./UploadImg-ai-v3.vue?vue&type=script&lang=ts"
export * from "./UploadImg-ai-v3.vue?vue&type=script&lang=ts"
import style0 from "./UploadImg-ai-v3.vue?vue&type=style&index=0&id=7ef06dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef06dda",
  null
  
)

export default component.exports